module.exports = __webpack_public_path__ + "img/bg_elment.b1907444.png";